import BankInfo from './BankInfo';
import ContactInfo from './ContactInfo';
import StoresList from './StoresList';
import MediaInfo from './MediaInfo';

export default { StoresList, ContactInfo, BankInfo, MediaInfo };
